<template>
  <div class="cashback-modal__layout">
    <div class="cashback-modal">
      <div class="cashback-modal__close" @click="toggleModal(false)"></div>
      <div class="cashback-modal__wrapper">
        <div class="cashback-modal__title">{{ $t('cashback-modal.title') }}</div>
        <div class="cashback-modal__content">
          <div class="cashback-modal__table">
            <div class="cashback-modal__table-subtitle">{{ $t('cashback-modal.table.subtitle') }}</div>
            <div class="cashback-modal__table-header">
              <div class="cashback-modal__table-header-item">{{ $t('cashback-modal.table.th1') }}</div>
              <div class="cashback-modal__table-header-item">{{ $t('cashback-modal.table.th2') }}</div>
              <div class="cashback-modal__table-header-item">{{ $t('cashback-modal.table.th3') }}</div>
            </div>
            <div class="cashback-modal__table-body">
              <div class="cashback-modal__table-body-row">
                <div class="cashback-modal__table-body-row-item">{{ $t('cashback-modal.table.row1.td1') }}</div>
                <div class="cashback-modal__table-body-row-item">3%</div>
                <div class="cashback-modal__table-body-row-item">5%</div>
              </div>
              <div class="cashback-modal__table-body-row">
                <div class="cashback-modal__table-body-row-item">{{ $t('cashback-modal.table.row2.td1') }}</div>
                <div class="cashback-modal__table-body-row-item">3%</div>
                <div class="cashback-modal__table-body-row-item">5%</div>
              </div>
              <div class="cashback-modal__table-body-row">
                <div class="cashback-modal__table-body-row-item">
                  <span>{{ $t('cashback-modal.table.row3.td1') }}</span>
                  <img src="@/assets/images/icons/priority-label.png" alt="priority">
                </div>
                <div class="cashback-modal__table-body-row-item">5%</div>
                <div class="cashback-modal__table-body-row-item">5%</div>
              </div>
              <div class="cashback-modal__table-body-row">
                <div class="cashback-modal__table-body-row-item">{{ $t('cashback-modal.table.row4.td1') }}</div>
                <div class="cashback-modal__table-body-row-item">3%</div>
                <div class="cashback-modal__table-body-row-item">5%</div>
              </div>
              <div class="cashback-modal__table-body-row">
                <div class="cashback-modal__table-body-row-item">{{ $t('cashback-modal.table.row5.td1') }}</div>
                <div class="cashback-modal__table-body-row-item">3%</div>
                <div class="cashback-modal__table-body-row-item">5%</div>
              </div>
            </div>
          </div>
          <div class="cashback-modal__block">
            <div class="cashback-modal__block-left">
              <div class="cashback-modal__block-header">
                <img src="@/assets/images/superapp-logo.png" alt="logo">
                <span>{{ $t('cashback-modal.block1.title') }}</span>
              </div>
              <div class="cashback-modal__block-subtitle">{{ $t('cashback-modal.block1.subtitle1') }}</div>
              <ul>
                <li>{{ $t('cashback-modal.block1.ul.li1') }}</li>
                <li>{{ $t('cashback-modal.block1.ul.li2') }}</li>
                <li>{{ $t('cashback-modal.block1.ul.li3') }}</li>
                <li>{{ $t('cashback-modal.block1.ul.li4') }}</li>
              </ul>
              <div class="cashback-modal__block-subtitle">{{ $t('cashback-modal.block1.subtitle2') }}</div>
              <p>{{ $t('cashback-modal.block1.p') }}</p>
            </div>
            <div class="cashback-modal__block-right">
              <div class="cashback-modal__block-header">
                <img src="@/assets/images/web.png" alt="web">
                <span>{{ $t('cashback-modal.block2.title') }}</span>
              </div>
              <div class="cashback-modal__block-subtitle">{{ $t('cashback-modal.block2.subtitle1') }}</div>
              <p>{{ $t('cashback-modal.block2.p1') }}</p>
              <div class="cashback-modal__block-subtitle">{{ $t('cashback-modal.block2.subtitle2') }}</div>
              <p>{{ $t('cashback-modal.block2.p2') }}</p>
            </div>
          </div>
          <div class="cashback-modal__footer">
            <img src="@/assets/images/info.png" alt="info">
            <p>{{ $t('cashback-modal.footer.text') }}</p>
          </div>
          <a :href="$t('cashback-modal.btn.link')" target="_blank" class="cashback-modal__btn">
            {{ $t('cashback-modal.btn.text') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'CashbackModal',
    data() {
        return {

        }
    },
    methods: {
      toggleModal(data) {
        this.$emit('toggleModal', data);
      }
    }
}
</script>